export default __webpack_public_path__ + "static/media/bizventurepojmovnik.dc0f10d4.pdf";